import React from 'react';

// import { Beforeunload } from 'react-beforeunload';

/**
 * @type {function}
 * @desc A Higher-Order-Component to enhance functionality of `Component`
 * @param {object} Component - A React component
 * @example
 * import { withExitWarning, WithExitWarning } from 'ui/hoc/withExitWarning';
 * import { testView as TestView } from 'views/Test.view';
 *
 * // create a component
 * const ComponentWithHOC = WithExitWarning( TestView );
 * @return {class} - A standard React component
 */
const withExitWarning = ( Component ) => {
    class WithExitWarning extends React.Component {
        constructor( props ) {
            super( props );
        }

        render() {
            
            /* return (
                <Beforeunload onBeforeunload={ ( event ) => event.preventDefault() }>
                    <Component { ...this.props } />
                </Beforeunload>
            ); */

            return (
                <Component { ...this.props } />
            );
        }
    }

    // set display name
    WithExitWarning.displayName = 'WithExitWarning';

    // set default props
    WithExitWarning.defaultProps = {};

    // return class
    return WithExitWarning;
};

export { withExitWarning };
